"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hooks = require("@datepicker-react/hooks");
var _dayjs = _interopRequireDefault(require("dayjs"));
var _datepickerContext = _interopRequireDefault(require("../datepickerContext"));
var _Month = _interopRequireDefault(require("../Month"));
var _constants = require("../../../utils/constants");
var _dates = require("../../../utils/dates");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// eslint-disable-next-line react/display-name
const Calendar = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    incomingStartDate,
    incomingEndDate,
    minAvailableDate,
    maxAvailableDate,
    startDate,
    endDate,
    numberOfMonths,
    onDateChange,
    monthRef
  } = props;
  const [state, setState] = (0, _react.useState)({
    startDate: monthRef ? null : new Date((0, _dayjs.default)(startDate).format(_constants.DEFAULT_DATE_FORMAT_FOR_CALENDAR)),
    endDate: new Date((0, _dayjs.default)(endDate).format(_constants.DEFAULT_DATE_FORMAT_FOR_CALENDAR)),
    START_DATE: _hooks.START_DATE
  });
  (0, _react.useEffect)(() => {
    if (startDate && endDate) {
      setState((0, _dates.buildCalendarStateObject)(startDate, endDate, _hooks.START_DATE));
    }
  }, [startDate, endDate]);
  function handleDateChange(data) {
    const isBeforeIncomingEndDate = (0, _dayjs.default)(data.startDate).isBefore((0, _dayjs.default)(incomingEndDate));
    const propertyToUpdate = isBeforeIncomingEndDate ? 'startDate' : 'endDate';
    setState({
      ...state,
      [propertyToUpdate]: data.startDate
    });
    onDateChange({
      ...state,
      [propertyToUpdate]: data.startDate,
      focusedInput: isBeforeIncomingEndDate ? _hooks.END_DATE : _hooks.START_DATE
    });
  }
  const {
    firstDayOfWeek,
    activeMonths,
    isDateSelected,
    isDateHovered,
    isFirstOrLastSelectedDate,
    isDateBlocked,
    isDateFocused,
    focusedDate,
    onDateHover,
    onDateSelect,
    onDateFocus,
    goToPreviousMonths,
    goToNextMonths
  } = (0, _hooks.useDatepicker)({
    startDate: state.startDate,
    endDate: state.endDate,
    focusedInput: state.focusedInput,
    onDatesChange: handleDateChange,
    minBookingDate: new Date((0, _dayjs.default)(minAvailableDate).format(_constants.DEFAULT_DATE_FORMAT_FOR_CALENDAR)),
    maxBookingDate: new Date((0, _dayjs.default)(maxAvailableDate).format(_constants.DEFAULT_DATE_FORMAT_FOR_CALENDAR)),
    firstDayOfWeek: 7,
    numberOfMonths: numberOfMonths || (0, _dates.calculateNumberOfMonths)(maxAvailableDate, minAvailableDate),
    initialVisibleMonth: new Date((0, _dayjs.default)(minAvailableDate)),
    changeActiveMonthOnSelect: false
  });
  (0, _react.useImperativeHandle)(ref, () => ({
    previousMonth() {
      goToPreviousMonths();
    },
    nextMonth() {
      goToNextMonths();
    }
  }));
  return /*#__PURE__*/_react.default.createElement(_datepickerContext.default.Provider, {
    value: {
      focusedDate,
      isDateFocused,
      isDateSelected,
      isDateHovered,
      isDateBlocked,
      isFirstOrLastSelectedDate,
      onDateSelect,
      onDateFocus,
      onDateHover,
      start: state.startDate,
      end: state.endDate,
      incomingStartDate: new Date((0, _dayjs.default)(incomingStartDate).format(_constants.DEFAULT_DATE_FORMAT_FOR_CALENDAR)),
      incomingEndDate: new Date((0, _dayjs.default)(incomingEndDate).format(_constants.DEFAULT_DATE_FORMAT_FOR_CALENDAR))
    }
  }, activeMonths.map(month => /*#__PURE__*/_react.default.createElement(_Month.default, {
    monthRef: "".concat(month.year, "-").concat(month.month + 1) === (0, _dayjs.default)(startDate).format('YYYY-M') && monthRef ? monthRef : null,
    focusedInput: state.focusedInput,
    key: "".concat(month.year, "-").concat(month.month),
    year: month.year,
    month: month.month,
    firstDayOfWeek: firstDayOfWeek
  })));
});
Calendar.propTypes = {
  incomingStartDate: _propTypes.default.string,
  incomingEndDate: _propTypes.default.string,
  minAvailableDate: _propTypes.default.string,
  maxAvailableDate: _propTypes.default.string,
  startDate: _propTypes.default.instanceOf(Date),
  endDate: _propTypes.default.instanceOf(Date),
  numberOfMonths: _propTypes.default.number,
  onDateChange: _propTypes.default.func
};
Calendar.defaultProps = {
  incomingStartDate: '2021-03-20',
  incomingEndDate: '2021/03/25',
  minAvailableDate: '2021/03/5',
  maxAvailableDate: '2021/04/25',
  startDate: new Date(),
  endDate: new Date(),
  numberOfMonths: 2,
  onDateChange: () => {}
};
var _default = exports.default = Calendar;